import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propNumber, propStr, propValidate, } from '../../../../helpers/custom-prop-types';
import PlainInputField from './PlainInputField';
const PlainInputFieldAndLabel = ({ afterPrefix, className, disabled, label, maxLength, name, placeholder, showError, type, validate, }) => (_jsxs("div", Object.assign({ className: 'form form-solution' }, { children: [_jsx("h3", { children: label }), _jsx(PlainInputField, { afterPrefix: afterPrefix, className: className, disabled: disabled, maxLength: maxLength, name: name, placeholder: placeholder, showError: showError, type: type, validate: validate })] })));
PlainInputFieldAndLabel.propTypes = {
    afterPrefix: propStr(),
    className: propStr(),
    disabled: propBool(),
    label: propStr().isRequired,
    maxLength: propNumber(),
    name: propStr().isRequired,
    placeholder: propStr(),
    showError: propBool(),
    type: propStr(),
    validate: propValidate(),
};
PlainInputFieldAndLabel.defaultProps = {
    afterPrefix: '',
    className: 'input-form-text',
    disabled: false,
    maxLength: null,
    placeholder: '',
    showError: true,
    type: 'text',
    validate: [],
};
export default PlainInputFieldAndLabel;
